export class EventStatisticsEntity {
    public viewCount: number = 0;

    public static fromDto(dto: any): EventStatisticsEntity {
        const entity = new EventStatisticsEntity();
        entity.viewCount = dto?.viewCount ?? 0;
        return entity;
    }
}
